'use client'

import { ReactNode } from 'react'

import { buildCreatePath } from '~/app/accounts/create/createRoutes'
import { Button } from '~/components/component-library'
import { MAX_CARDS_PER_ORG } from '~/constants/cards'
import { useCards } from '~/hooks/useCards'

// Rendered in the accounts page's Cards tab header and its empty state.
export const AddCardButton = ({
  children = 'Add address',
}: {
  children?: ReactNode
}) => {
  const { cards } = useCards()
  const isAtCap = cards.length >= MAX_CARDS_PER_ORG

  return (
    <Button
      isDisabled={isAtCap}
      disabledReason={`Workspaces can watch up to ${MAX_CARDS_PER_ORG} card addresses`}
      href={{
        path: buildCreatePath({
          type: 'card',
          returnTo: '/accounts?tab=cards',
        }),
      }}
    >
      {children}
    </Button>
  )
}
